import { render, staticRenderFns } from "./AncestralTabletsEngraving.vue?vue&type=template&id=1afa0b22&"
import script from "./AncestralTabletsEngraving.vue?vue&type=script&lang=js&"
export * from "./AncestralTabletsEngraving.vue?vue&type=script&lang=js&"
import style0 from "./AncestralTabletsEngraving.vue?vue&type=style&index=0&id=1afa0b22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports